export interface UserRole {
	name?: string;
	key?: string;
	rank: number;
	title: string;
}
